// Adresy zewnętrznych usług — z VUE_APP_* z produkcyjnymi wartościami domyślnymi.
export const API_URL = process.env.VUE_APP_API_URL || 'https://api.sledzgps.pl'
export const WS_URL = process.env.VUE_APP_WS_URL || 'https://websocket.sledzgps.com'
export const ASSETS_BASE_URL = process.env.VUE_APP_ASSETS_BASE_URL || 'https://sledzgps.pl'
// Widok wydarzenia na mapie (beta): `${BETA_URL}/events/{alias}`
export const BETA_URL = process.env.VUE_APP_BETA_URL || 'https://beta.sledzgps.pl'
// Logotypy partnerów wydarzenia (sledz-api event_sponsors, pole `sponsors` w /events/alias) — ten sam
// serwer co w becie (VUE_APP_SPONSOR_LOGOS_URL w sledz-app)
export const SPONSOR_LOGOS_BASE_URL = process.env.VUE_APP_SPONSOR_LOGOS_URL || 'https://sledzkropki.pl/files/sponsors/'
// Strona ŚledźGPS w stopce
export const SLEDZGPS_HOME_URL = process.env.VUE_APP_HOME_URL || 'https://sledzgps.pl'
